import React from "react";
import {Grid, Tooltip} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {format, formatDistance, formatRelative, intervalToDuration, parseISO, subDays} from 'date-fns'
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";
import {useSelector} from "react-redux";


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    shape: {
        display: 'inline-block',
        backgroundColor: 'blue', // theme.palette.primary.main,
        width: 10,
        height: 10,
    },
    shapeCircle: {
        borderRadius: '50%',
    },
}));

const etapaCor =  etapa  => {
    switch (etapa) {
        case 1: // recebimento
            return 'gray'
            break;
        case 2: // limpeza/secagem
            return 'gray'
            break;
        case 4: // exi
            return 'rgb(31,119,180)'
            break;
        case 7: // rasp
            return 'rgb(255,127,14)'
            break;
        case 9: // esc
            return 'rgb(44,160,44)'
            break;
        case 12: // con
            return 'rgb(214,39,40)'
            break;
        case 14: // cola
            return 'rgb(148,103,189)'
            break;
        case 16: // ench
            return 'rgb(140,86,75)'
            break;
        case 18: // aplb
            return 'rgb(227,119,194)'
            break;
        case 20: // envel
            return 'rgb(127,127,127)'
            break;
        case 21: // mont
            return 'rgb(188,189,34)'
            break;
        case 22: // vulc
            return 'rgb(23,190,207)'
            break;
        case 24: // exf
            return 'blue'
            break;
        case 25: // concluido
            return 'blue'
            break;
        case 26: // corte
            return 'blue'
            break;
        case 29: // trans etapa
            return 'blue'
            break;
        case 31: // saida
            return 'blue'
            break;
        default:
             return 'yellow'
    }
}


const OSEIndicador = ( { pe, ose,seqEtapaAtual } ) => {
    const classes = useStyles();
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    //const rectangle = (cor) => { return <div className={classes.shape} style={{ backgroundColor: etapaCor(cor) }}  />};
    const circle = (cor) => { return <div className={clsx(classes.shape, classes.shapeCircle)} style={{ backgroundColor: cor }} />};

    let status = 1;
    let cor = 'blue';

    let duracao = 0;
    if (ose && ose.DTInicioProducao && ose.DTFimProducao) {
        duracao =
            renderMilisecondsToTimeDuration(new Date(ose.DTFimProducao).getTime() -  new Date(ose.DTInicioProducao).getTime());
    }
    if (ose && ose.DTInicioProducao && ose.DTInicioProducao < periodMin) {
        status = -1
    }
    if (ose && ose.DTInicioProducao && ose.DTInicioProducao > periodMax) {
        status = 2
    }

    const questoes =() => {
        if (ose && ose.ordemServicoEtapaQuestaos) {
            return (
                <React.Fragment>
                    {
                        ose.ordemServicoEtapaQuestaos.map(q => {
                           return (<p> {q.processoEtapaQuestao.pergunta}: {q.resposta}</p>);
                        })
                    }
                </React.Fragment>
            )

        }
    }


    let legenda = "";
    if (ose) {
        legenda = <span>`{pe.descricao} - {format(parseISO(ose.DTInicioProducao),"dd/MM HH:mm")} - {duracao} - {ose.operador? ose.operador.abreviatura : ""} `{questoes()}</span>
    } else {
        legenda = <span>`{pe.descricao} - NÃO REGISTRADO.`</span>;
        status = -2
    }

    // conserto
    if (pe.etapaId === 12 && pe.temConserto && pe.temConserto === "N") {
        status = -3
    }

    if (pe.sequencia >= seqEtapaAtual) {
        status = 3;
    }

    switch (status) {
        case -3: // desnecessaria
            cor = 'gray'
            break;
        case -2: // etapa nao preenchida
            cor = 'red';
            break;
        case -1: // antes do periodo Minimo
            cor = 'rgb(23,190,207)'
            break;
        case 2: // apos o periodo Maximo
            cor = 'rgb(23,190,207)'
            break;
        case 3: // ainda nao executado
            cor = 'rgb(228,235,247)'
            break;

        default:
            cor = 'blue';
    }



    return (
        <React.Fragment>
            <Grid item>
                    {/*<Typography>{ose.processoEtapaId} {ose.processoEtapa.etapaId}  </Typography>*/}
                    {/*{rectangle(ose.processoEtapa.etapaId)}*/}
                    {/*{ circle(ose.processoEtapa.etapaId) }*/}
                <Tooltip title={legenda} aria-label="add">
                    { circle(cor) }
                </Tooltip>
            </Grid>

        </React.Fragment>
    );
}

export default OSEIndicador;
